import { ApiModel } from 'base'

export default class ImageGallery extends ApiModel
  @prop 'uid', -> "gallery:#{this.id}"
  @prop 'title', -> @smartButton?.title
